module.exports = __webpack_public_path__ + "fonts/96559ff.ttf";